export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";